<div *ngIf="tag != undefined" class="app-box-shadow-depth-1 rounded-circle d-flex align-items-center justify-content-center animated fadeInLeft" 
  [ngClass]="{ 'app-tags-icons-item-first': isFirst, 'app-tags-icons-item': !isFirst }"
  [ngStyle]="{ 'background-color': tag.color.hexa }"
  mdbTooltip="{{ tag.labels.value(language) }}" placement="top">
  <i class="{{ tag.icon.code }} white-text"></i>
</div>